import React from 'react';

import { Info as InfoIcon } from '@mui/icons-material';
import { List, ListItem, Stack, Typography } from '@mui/material';

import { numberWithCommas } from '@clearverify/utils';

import { StatesItemFragment } from 'src/api';
import { Tooltip } from 'src/components/common';

import { DashboardOverviewBlockListItem } from './DashboardOverviewBlockListItem';

type DashboardOverviewBlockDataPrivacyStatesProps = {
  states: StatesItemFragment[];
  lastUpdateDate: string;
  loading: boolean;
};

export const DashboardOverviewBlockDataPrivacyStates: React.FC<
  DashboardOverviewBlockDataPrivacyStatesProps
> = ({ states, lastUpdateDate, loading }) => {
  const tooltipTitle = React.useMemo(() => {
    if (states.length === 0) return null;

    return (
      <List dense>
        {states.map((state, index) => (
          <ListItem sx={{ fontSize: 10, fontWeight: 500, p: 0 }} key={state.name}>{`${index + 1}. ${
            state.name
          }`}</ListItem>
        ))}
      </List>
    );
  }, [states]);

  return (
    <DashboardOverviewBlockListItem
      loading={loading}
      number={numberWithCommas(states.length)}
      title={
        <Tooltip title={tooltipTitle} arrow>
          <Stack direction="row" alignItems="center">
            States with data privacy
            <InfoIcon sx={{ height: 16, color: theme => theme.palette.action.active }} />
          </Stack>
        </Tooltip>
      }
      subtitle={
        <Typography component="span" variant="body2">
          Last update: {lastUpdateDate}
        </Typography>
      }
    />
  );
};
